import React, {Component} from 'react';
import {inject, observer} from "mobx-react/index";
import PopupOpenImage from '../../../assets/images/popup-open.png';

@inject("store")
@observer
export default class PopupOpenIcone extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <img src={PopupOpenImage} alt="popup-open" className={`popup-open-icone ${this.props.className || ""}`}/>;
    }
}


// WEBPACK FOOTER //
// ./src/modules/comum/components/PopupOpenIcone.js